/**
 * ProfileSection Component
 * Reusable section wrapper with outlined Paper, icon+title header, and optional action slot.
 */

import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

export interface ProfileSectionProps {
  title: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  noPadding?: boolean;
}

export const ProfileSection: React.FC<ProfileSectionProps> = ({
  title,
  icon,
  action,
  children,
  noPadding = false,
}) => (
  <Paper variant="outlined" sx={{ mb: 3 }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2.5,
        py: 1.5,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {icon && (
          <Box sx={{ display: 'flex', color: 'primary.main' }}>{icon}</Box>
        )}
        <Typography variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
      </Box>
      {action && <Box>{action}</Box>}
    </Box>
    <Box sx={noPadding ? {} : { p: 2.5 }}>{children}</Box>
  </Paper>
);
